/*
 * Translation file for locale
 * ---------------------------------
 * Struct:
 *    // Common labeling Block
 *    common: {
 *       lbl1: 'YYYYY'
 *    },
 *    // Pages Block --> Seguir nombres de pages
 *    pages: {
 *       about: {
 *          lbl1: 'ZZZZ'
 *       }
 *    },
 *    // Compnents block --> Seguir misma estructura que ficheros
 *    components: {
 *       home: {
 *          NavigationBarComponent : {
 *              lbl1: 'XXXX'
 *          }
 *       }
 *    }
 *
 * */

export const pt = {
    defaultlocale: "pt-pt",
    common: {
        appname: "IRIS",
        btn_audit_trail: "Registro",
        btn_edit: "Editar",
        btn_delete: "Excluir",
        btn_cancel: "Cancelar",
        btn_ok: "Ok",
        btn_save: "Salvar",
        btn_review: "Revisão",
        btn_remove_review: "Ocultar revisão",
        btn_view_replies: "Respostas",
        lbl_success: "Alterações salvas com sucesso",
        lbl_error: "Error al guardar cambios",
        lbl_edit: "Editar",
        lbl_delete: "Excluir",
        lblClose: "Fechar",
        lblSave: "Salve",
        lblReset: "Redefinir",
        generatingfile: "Compressing files",
        errorgeneratingfile: "Error on Download",
        downloadingfile: "Downloading file",
        download: "Download",
        confirmdelete: "Tem certeza de que deseja excluir a seleção atual?",
        with: "com",
        modalAudit: {
            lblTitle: "Câmbio historial",
            msgNoChanges: "Mudanças não detectadas",
            lblUser: "Mudança feita por:",
            table: {
                colField: "Campo de dados",
                colBefore: "Antes",
                colAfter: "Próximo"
            }
        },
        modalExcel: {
            message: "Link para descarregar",
            link: "Descarregar Excel",
            error: "Erro ao criar excel",
            error413: "Limite de download excedido. Refine a filtragem."
        },
        comments: {
            title: "Comentários",
            btn_new: "Adicionar",
            btn_reply: "Responder",
            txt_newcomment: "Novo comentário",
            txt_comment_deleted: "Comentário deletado",
            btn_view_replies: "Respostas",
            msg_comm_deleted_confirm: "Isso excluirá esta mensagem. Prosseguir?",
            msg_comm_added_success: "Comentario añadido",
            msg_comm_added_error: "El comentario no se ha podido añadir",
            msg_comm_edited_success: "Comentario editado",
            msg_comm_edited_error: "El comentario no se ha podido editar",
            msg_comm_deleted_success: "Comentario eliminado",
            msg_comm_deleted_error: "El comentario no se ha podido eliminar"
        },
        documents: {
            TITLE: "Documentos",
            colModel: {
                Name: "Nome do Documento",
                Description: "Descrição",
                Type: "Tipo",
                PicType: "Tipo de imagem",
                Date: "Data",
                ExpDate: "Data de validade",
                AddReport: "Adicionar relatório",
                IsConfidential: "Confidencial",
                MinSecLevel: "Min Sec Level",
                toSign: "Para Assinatura"
            },
            ToolbarHints: {
                Edit: "Editar seleção",
                Delete: "Excluir seleção",
                Miniatures: "Ver miniaturas",
                Gallery: "Veja a galeria",
                Audit: "Aud.",
                Folder: "Adicionar pasta",
                ListAll: "Ver excluídos",
                ListActive: "Ver apenas ativo",
                Download: "Baixar seleção",
                BackToDocs: "Voltar para a lista de documentos"
            },
            AddFolderModal: {
                Title: "Adicionar pasta",
                Message: "Por favor, insira o nome da pasta",
                FolderName: "Nome da pasta",
                msg_toasted_added: "Nova pasta adicionada!",
                msg_toasted_no_added:
                    "Ocorreu um problema ao adicionar a nova pasta, tente novamente",
                msg_toasted_zipEmpty: "ZIP VAZIO!!!",
                msg_toasted_no_name:
                    "O nome deve ser preenchido para adicionar uma nova pasta"
            },
            DownloadZipModal: {
                Title: "Baixar ZIP",
                Message: "Um único arquivo ZIP será baixado com",
                Confirm:
                    " documentos. Este download pode demorar um minuto, tem certeza?",
                msg_toasted_zipOK: "ZIP criado !! Baixando...",
                msg_toasted_zipERROR: "Ocorreu um erro ao criar o ZIP. Tente novamente"
            },
            EditModal: {
                msg_toasted_edited: "Documentos editados !!",
                msg_toasted_no_edited:
                    "Ocorreu um erro ao editar os documentos. Tente novamente!!",
                    greaterThan100Mb: "O documento excede o limite de 100 Mb imposto pela Adobe para processamento de documentos"
            },
            DeleteModal: {
                Message: "Tem certeza que deseja excluir os documentos selecionados?",
                msg_toasted_deleted: "Documentos excluídos !!",
                msg_toasted_no_deleted:
                    "Ocorreu um erro ao excluir documentos. Tente novamente!!"
            },
            DropZone: {
                AddBtn: "Mostrar zona de lançamento de documentos",
                RemoveBtn: "Ocultar zona para soltar documentos",
                IsConfidentialBtn: "Marque os documentos anexados como confidenciais",
                DropFileText: "Solte o arquivo (não duplique os nomes) ",
                DropFileBtn: "Selecione o arquivo",
                UploadBtn: "Faça upload de todos os arquivos",
                UploadedMsg: "Carregado",
                UploadedErrorMsg: "Upload fail",
                ReadyToUploadMsg: "Pronto para fazer upload"
            },
            dueDiligence: {
                title: "Due Diligence"
            }
        }
    },
    pages: {
        about: {
            table: {
                colname: "Nome",
                coltitle: "Pseudônimo"
            },
            name: "Em formação"
        },
        sample: {
            name: "Nome",
            type: "Tipologia",
            code: "Código",
            search: "Procurar",
            country: "País"
        }
    },
    components: {
        navigation_bar: {
            title_users: "Usuários",
            title_roles: "Funções",
            title_profiles: "Perfis",
            title_refresh_cache: "Atualizar cache",
            title_esign: "ESIGN",
            title_esign_JLL: "JLL",
            title_esign_TETRIS: "TÉTRIS",
            title_esign_dashboard: "DASHBOARD",
            title_esign_JLLT: "JLLT",
            title_esign_HR: "HR",
            title_esign_minus: "ESign",
            title_due_diligence: "Due Diligence",
            title_informa: "Informa",
            title_approvers: "ESign Approvers",
            title_authmappings: "Auth Mappings",
            title_healthchecks: "Healthchecks",
            esignmanuales: "ESign Manual",
            esignmanualpt: "Guia de Utilização do E- Sign Portugal",
            esignmanualresidentialpt: "Guia de Utilização do E- Sign Residential",
            esignmanualtetrispt: "Guia de Utilização do E-Sign Tétris"
        },
        dynamicfilters: {
            field: "Propriedade a filtrar",
            operation: "Operation",
            setvalue: "Valor",
            selectvalue: "Valores",
            notvalid: "Este filtro não está completo"
        },
        pagination: {
            of: "de",
            rows: "lihnas"
        },
        genericTable: {
            columnList: {
                modalTitle: "Lista de colunas disponíveis",
                index: "N",
                column: "Coluna",
                isVisible: "Visível",
                msgConfigSaved: "Configuração salva.",
                msgConfigSavedErr: "Erro ao salvar configuração."
            }
        },
        esignapproversmanagement: {
            addedsentence: "O usuário {email} será adicionado com o nome {name} como aprovação para o area {area} na entidade jurídica {legalentity}",
            deletedsentence: "O usuário {email} com o nome {name} deixará de ser aprovação para o area {area} na entidade jurídica {legalentity}",
            email: "Email",
            name: "Nome",
            area: "Area",
            addapprover: "Adicionar Aprovador",
            commit: "Salvar",
            email_validation: "O e-mail é um campo obrigatório",
            area_validation: "Área é um campo obrigatório",
            name_validation: "O nome é um campo obrigatório",
            title: "Gestão de aprovações",
            addedstage: "Aprovadores para adicionar",
            soleedstage: "Aprovadores para remover",
            filtervalidation: "Não é permitido salvar as alterações enquanto os filtros estiverem ativos",
            itemexists: "Este item já existe"
        },
        role: {
            name_label: "Função",
            overview_label: "Descrição",
            title: "Funções",
            edit_title: "Editar funções",
            create_title: "Nova função",
            name_validation: "O nome é obrigatório",
            overview_validation: "Descrição é obrigatória"
        },
        profile: {
            title: "Perfis",
            associates_title: "Funções associadas ao perfil",
            name_label: "Perfil",
            overview_label: "Descrição",
            edit_title: "Editar Perfil",
            create_title: "Novo Perfil",
            assign_role_title: "Atribuir função",
            name_validation: "O nome é obrigatório",
            overview_validation: "Descrição é obrigatória"
        },
        user: {
            title: "Usuários",
            associates_title: "Perfis associadas ao usuário",
            name_label: "Usuário",
            email_label: "E-mail",
            from_label: "Copiar perfis de usuário",
            to_label: "para o usuário",
            edit_title: "Editar usuário",
            create_title: "Novo usuário",
            assign_profile_title: "Atribuir Perfil",
            copy_profiles_title: "Copiar Perfis",
            name_validation: "O nome é obrigatório",
            email_validation: "E-mail é obrigatório",
            not_same_user_validation: "Os usuários selecionados não devem ser os mesmos"
        },
        dueDiligence: {
            title: "Due Diligence",
            status: "Estado",
            persontype: "Entidade legal/Pessoa singular",
            country: "País",
            providertype: "Contrapartida",
            clienttype: "Tipo de risco",
            RB: "Baixo Risco",
            RM: "Risco médio",
            RA: "Alto risco",
            EX: "Excluído",
            PF: "Pessoa natural",
            CIF: "CIF",
            country_validation: "O país é obrigatório",
            CIF_validation: "CIF é obrigatório",
            clientdescription: "Nome do cliente",
            clientdescription_validation: "O nome do cliente é obrigatório",
            providertypeparam: "Contrapartida",
            providertypeparam_validation: "A contrapartida é obrigatória",
            naturalpersonparam: "Modelo",
            naturalpersonparam_validation: "O tipo é obrigatório",
            pbcclientparam: "Modelo",
            pbcclientparam_validation: "O tipo é obrigatório",
            ispep: "É uma pessoa potencialmente exposta",
            ispep_validation: "Este campo é obrigatório",
            startdate: "Data de início",
            startdate_validation: "A data de início é obrigatória",
            enddate: "Data de fechamento",
            enddate_validation: "A data de fechamento é obrigatória",
            persontype: "Entidade legal/Pessoa singular",
            persontype_validation: "O tipo de pessoa é obrigatório",
            email: "o email",
            addemail: "Digite um endereço de e-mail válido e pressione a tecla Enter",
            changestatus_title: "Alterar status",
            changestatus_validation: "Você deve selecionar um status para alterar",
            changestatus_unchanged_validation:
                "Não é possível selecionar o status atual",
            nextstatus: "Novo Status",
            create_title: "Novo Registro",
            update_title: "Editar Registro",
            statustrack_title: "Trilha de status de mudança",
            mailcommentcreate: "O usuário <b>{user}</b> adicionou um comentário sobre o arquivo<b> {description} ({cif})</b>.",
            mailcommentedit: "O usuário <b>{user}</b> editou um comentário sobre o arquivo<b> {description} ({cif})</b>.",
            mailcommentreply: "O usuário <b>{user}</b> respondeu a um comentário sobre o arquivo<b> {description} ({cif})</b>."
        },
        statustable: {
            status: "Status",
            date: "Data",
            deltatime: "Tempo Delta",
            username: "Nome do usuário",
            sendreminder: "Mande um lembrete",
            reminderrecentlysent: "Um lembrete já foi enviado hoje"
        },
        informa: {
            title: "Informa",
            cif: "CIF",
            cif_name: "Nome",
            create_title: "Adicionar Informa CIF",
            cif_validation: "CIF é um valor obrigatório",
            cif_name_validation: "Nome é um valor obrigatório",
            edit_title: "Editar Informa CIF"
        },
        esigntetris: {
            estitle: "TÉTRIS ARQUITECTURA S.L.U.",
            ittitle: "Tetris Design & Build Srl",
            pttitle: "FITOUTETRIS S.A.",
            feesrange: "Fees - Valor de Referência",
            feesvalidation: "O valor do contrato não está dentro da faixa selecionada"
        },
        esigntetrisform: {
            partydetails: "DETALHES DA PARTE TÉTRIS",
            projectlocation: "Localizacion. proyecto",
            regionalclient: "Cliente Regional",
            structuralwork: "Existem obras estruturais ou de fachada, obras impermeáveis e/ou obras não habituais",
            structuralworkdetail: "Detalhe",
            protectedbuilding: "Obras relacionadas com Edificio Classificado/Protegido",
            protectedbuildingdetail: "Detalhe",
            licenseresponsability: "A Tétris é responsável por obter licenças administrativas?",
            licenseresponsabilitydetail: "Detalhe",
            workguaranteeperiod: "Garantia da Obra",
            workguaranteeperiodrange: "Faxia",
            bankguarantee: "Garantia Bancária/ Ou outro tipo de caução",
            bankguaranteerange: "Faxia",
            retention: "Retenções",
            retentionrange: "Faxia",
            penalties: "Penalidades",
            penaltiesamount: "Quantia",
            caponpenalties: "Limite de Penalizações por atraso",
            caponpenaltiesrange: "Faxia",
            includeriskanalisys: "Análise do risco do negócio?",
            riskanalisys: "ANÁLISE DO RISCO DO NEGÓCIO",
            anticorruptionclause: "Cláusula anticorrupção acrescentada no contrato",
            pcg: "Garantia da Empresa -Mãe",
            pricemodality: "Tipo de Preço?",
            pricemodalitydetail: "Detalhe",
            prepaid: "Adiantamento de preço",
            prepaidguarantee: "Garantia Bancária para Adiamento de Preço",
            prepaidamount: "Quantia",
            template: "Usando um template TÉTRIS?",
            feesRange: "Faixa de valor do contrato",
            fees: "Valor exato do contrato",
            feesvendor: "Preço Contratual",
            feesrangevalidation:
                "O valor do contrato não está dentro da faixa selecionada",
            durationofworks: "Duração da Obra",
            isocode: "ISO Code",
            tetrissoftcode: "Tetris Soft code",
            clientrequestnumber: "Client request number IRIS",
            legalliabilityyearsmsg: "De 3 a 10 anos de garantia legal",
            portugaliabilitymessage: "Garantia de 5 anos",
            signee1: "Assinatura Tétris (1)",
            signee2: "Assinatura Tétris (2)",
            projectnumber: "Número do projeto"
        },
        esign: {
            estitle: "JONES LANG LASALLE ESPAÑA, S.A.",
            ittitle: "JONES LANG LASALLE",
            pttitle: "JLL",
            configmessage:
                "Você não tem permissões suficientes para acessar esta seção da IRIS ou estão faltando alguns parâmetros de configuração",
            confirmstatuschageinternalsignature:"Você marcou esta solicitação para “aprovação interna” e nenhuma modificação é permitida durante a fase de aprovação. Depois de totalmente aprovado, você DEVE carregar o documento assinado externamente nesta mesma solicitação.",
            confirmstatuschage:
                "Certifique-se de ter anexado os documentos para aprovar e assinar e de concluir a inscrição. Se você aceitar, não poderá fazer modificações.",
            confirmcoveralert:
                "Lembre- se de que todos os documentos a serem assinados devem conter a verificação de assinatura - a ser modificada na janela do documento -",
            confirmsignature:
                "Tem certeza de que deseja enviar os documentos anexados para assinatura?",
            confirminternalsignature: "Você marcou este pedido para “aprovação interna”, NÃO deve pressionar “enviar para assinatura” até ter carregado o documento assinado externamente por ambas as partes, pois o pedido será encerrado sem possibilidade de modificação.",
            approval_title: "Aprovação",
            esignstatuswf: "Estado",
            counterparty: "Contraparte",
            persontype: "Entidade legal/Pessoa singular",
            legalentity: "Entidade Legal",
            area: "Area",
            segment: "Segmento",
            contracttype: "Tipo de contrato",
            feesrange: "Gama de honorários",
            approver: "Aprovador",
            mindate: "Data mínima de criação",
            maxdate: "Data máxima de criação",
            cancelconfirm: "Tem a certeza de que quer cancelar esta seleção",
            justifycomment: "Digite alguns comentários para justificar sua decisão:",
            approvaltext:
                "Depois de revisar o formulário preenchido pelo candidato, você deseja aprovar ou negar?.",
            add_approver_title: "Adicionar Aprovadores",
            cancel_title: "Cancelar Transação",
            approval_title: "Aprovar ou recusar transação",
            statustrack_title: "Histórico de alterações de estado",
            agreements_title: "Signatários",
            addapprovertext: "Digite um endereço de e-mail e pressione Enter para adicionar um aprovador extra para esta solicitação:",
            addapproveralert: "Aguarde o aprovador extra aprovar ou negar a solicitação para continuar com o processo de aprovação",
            emaillistvalidation: "É obrigatório fornecer pelo menos um e-mail",
            create_transaction: "New approval and sign request",
            review_transaction: "Review approval and sign request",
            edit_transaction: "Edit approval and sign request",
            nochangedvalidation: "O estado não mudou",
            feesvalidation:
                "As taxas inseridas não estão dentro do intervalo selecionado",
            inputsvalidation:
                "Os campos obrigatórios devem ser preenchidos e os documentos anexados antes de salvar",
            mailcommentcreate: "O usuário <b>{user}</b> adicionou um comentário no formulário <b>{description}</b> criado por {solicitant}.",
            mailcommentedit: "O usuário <b>{user}</b> editou um comentário no formulário <b>{description}</b> criado por {solicitant}.",
            mailcommentreply: "O usuário <b>{user}</b> respondeu ao seu comentário no formulário <b>{description}</b> criado por {solicitant}.",
            approvaltooltip: "Aprovar ou negar",
            sendtosigntooltip: "Enviar para assinar",
            projectnumber: "Número do projeto"
        },
        dashboards: {
            tetrisTitle: "Número de contratos por categoria"
        },
        esignform: {
            partydetails: "Elementos de Identificação da JLL",
            counterpartydetails: "Elementos de Identificação da Contraparte/Cliente",
            contractdetails: "Detalhes do Contrato",
            signees: "Assinaturas",

            description: "Número do Pedido",
            solicitantName: "Nome do Requerente",
            solicitantMail: "E-mail do Requerente",
            behalf: "Solicitado em nome de...",
            legalEntity: "Entidade Jurídica JLL",
            area: "Area",
            segment: "Segmento",
            subsegment: "Subsegmento",
            approver: "Aprovação /Line Manager",
            oportunityNum: "Num. Oportunidad (CRM)",
            feesrangevalidation:
                "As taxas inseridas não estão dentro do intervalo selecionado",
            liability: "Limite de Responsabilidade",
            counterparty: "Contraparte",
            personType: "Pessoa Colectiva/Pessoa Singular",
            contractType: "Tipo de contrato",
            startDate: "Data de inicio do Contrato",
            endDate: "Data final do contrato",
            template: "Usando um template JLL?",
            reviewed: "Revisto por Advogado",
            object: "Objecto",
            activeName: "Nome do Ativo/ Morada Completa",
            feesRange: "Fees - Valor de Referência",
            fees: "Fees (exactos)",
            id: "ID",
            namesurname: "Apelido, Nome",
            vat: "VAT",
            companyname: "Denominação social",

            executed: "Contrato executado e assinado",
            onlyInternalApproval: "Contrato somente para aprovação interna",
            counter: "Contrato assinado pela contraparte",
            counterPartySignees: "Emails para assinatura da contraparte",
            signee1: "Assinatura JLL (1)",
            signee2: "Assianturas JLL (2)",
            addMeasures: "Outros...",
            endOfWOrks: "Fim da Obra",
            endDateNP: "End contract notice",
            projectname: "Nome do projeto",
            leasingpercentage: "% do preço de compra/arrendamento"
        },

        stepper: {
            initial_status: "Estado Inicial",
            cover_completed: "Submissão completa",
            approval_completed: "Aporvação Completa",
            sent_to_sign: "Enviado para Assinatura",
            signature_completed: "Assinatura Completa",
            linemanager: "Aprovação - Line Manager",
            datacontroller: "Aprovação - Data Controller",
            dccorporate: "Aprovação - DC Corporate",
            hr: "Aprovação - HHRR",
            ceo: "Aprovação - CEO",
            cfo: "Aprovação - CFO",
            legalandcompliance: "Aprovação - Legal & Compliance",
            hs: "Aprovação - Health Safety",
            finance: "Aprovação - Finance",
            compliance: "Aprovação - Compliance",
            legal: "Aprovação - Legal",
            datacontroller: "Aprovação - Data Controller",
            resiblegal: "Aprovação - Resi B. Legal",
            leaderbline: "Aprovação - Leader B. Line",
            hse: "Aprovação - HSE",
            controller: "Aprovação - Controller",
            documentcontroller: "Aprovação - Document Controller"
        },
        approval: {
            comment_validation: "Você deve incluir um comentário"
        },
        counterparty: {
            client: "Client",
            vendor: "Vendor / collaborator"
        },
        ddd: {
            client: {
                title: "Declaração CDD*",
                titleportugal: "Declaração CDD*",
                body:
                    "I declare I have conducted all the following checks on the Client and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                li1: "Financial / Solvency Check",
                li2: "Conflict of Interest Check",
                li3: "Reputational Check",
                li4: "Legal Due Diligence (PoA)",
                li5: "AML Check / Sanctions (if applicable)",
                li6: "Additional measures: (please enter) free text",
                check1: "I confirm that the Company has capacity to serve this Client.",
                check2:
                    "I confirm that the Client is suitable and do not present risks as a result of the DD."
            },
            vendor: {
                title: "Declaração VDD*",
                body:
                    "I declare I have conducted all the following checks on the Vendor / Collaborator and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                li1: "Reputational Risk",
                li2: "Financial/Solvency Risk",
                li3: "Technical/professional Capacity of the Vendor",
                li4: "Adherence to Vendor Code of Conduct (policy 36)",
                li5: "Check sufficent Insurance cover",
                li6: "Check up-to date on payments to Social Security",
                li7: "Check up-to date on payments to Treasury",
                li8: "Additional measures: Free text",
                check1:
                    "I confirm that the Vendor / Collaborator is suitable and do not present risks as a result of the DD."
            }
        },
        dddtetris: {
            client: {
                title: "DECLARATION CDD*",
                titleportugal: "DECLARATION CDD*",
                body:
                    "I declare I have conducted all the following checks on the Client and I keep good record of it, as stated in Global Policy 11 and Local Procedures",
                li1: "Financial / Solvency Check",
                li2: "Conflict of Interest Check",
                li3: "Reputational Check",
                li4: "Legal Due Diligence (PoA)",
                li5: "AML Check / Sanctions (if applicable)",
                li6: "Additional measures: (please enter) free text",
                check1: "I confirm that the Company has capacity to serve this Client.",
                check2:
                    "I confirm that the Client is suitable and do not present risks as a result of the DD.",
                check3:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                itcheck1: "Declaro que a empresa tem capacidade para assinar o documento e cumprir as obrigações nele contidas para com o Cliente",
                itcheck2: "Declaro que o Cliente é uma pessoa idônea e não apresenta riscos."
            },
            vendor: {
                title: "DECLARATION VDD*",
                body:
                    "I declare I have conducted all the following checks on the Vendor / Collaborator and I keep good record of it, as stated in Global Policy 40 and Local Procedures",
                li1: "Reputational Risk",
                li2: "Financial/Solvency Risk",
                li3: "Technical/professional Capacity of the Vendor",
                li4: "Adherence to Vendor Code of Conduct (policy 36)",
                li5: "Check sufficent Insurance cover",
                li6: "Check up-to date on payments to Social Security",
                li7: "Check up-to date on payments to Treasury",
                li8: "Additional measures: Free text",
                check1:
                    "I confirm that the Vendor / Collaborator is suitable and do not present risks as a result of the DD.",
                check2:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                    itcheck1: "Declaro que a empresa tem capacidade para assinar o documento e cumprir as obrigações nele contidas perante o Fornecedor/Colaborador",
                    itcheck2: "Declaro que o Fornecedor/Colaborador é uma pessoa idônea e não apresenta riscos.",
                    itcheck3: "Eu levei em conta, solicitado e obtido todas as aprovações necessárias (se aplicável), de acordo com as políticas internas vigentes da JLL e/ou Tetris"
            },

        },
        authorizationmappings: {
            controllertitle: "Controller Mappings",
            actiontitle: "Action Mappings",
            action: "Action",
            controller: "Controller",
            indb: "in Database",
            attribute: "Added attribute",
            assembly: "Exists",
            role: "Role",
            roles: "Roles",
            controllerform: "Controller authorization mappings",
            actionform: "Action authorization mappings",
            rolelist_validation: "Select one role at least",
            controller_validation: "Please type or select a controller",
            action_validation: "Please type or select a action"
        },
        contracttype: {
            nda: "NDA",
            ndainside: "NDA Inside Information",
            advisory: "(Just) Advisory or Consultancy",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdspjmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            consultancy: "Consultancy",
            subcontractingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            collaborationsp: "Collaboration (Service Provider)",
            otherservices: "Other Services (please indicate)",
            internalpurchases: "Internal Purchases (no revenue related)",
            design: "Design (only)",
            otherservicesnoconstruction: "Other services (not build)",
            otherservicesrelatedbuild: "Other services related to Build",
            construction: "Build (only)",
            designandconstruction: "Design and Build",
            furnituresupply: "Furniture Supply",
            extensionofworkorservice: "Novation Variations or Extraworks ",
            masterserviceagreement: "Master Service Agreement",
            certificateofmeetings: "Construction Meetings",
            furniturelogisticsoperator: "Logistic Operator",
            discount: "Volume Discount Contracts (Rappel, prescription)",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Installation of Materials (only) ",
            instalationandmaterials: "Instalação e Materiais",
            corporatepurchases: "Corporate Procurement (support)",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Recibo IT",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        },
        contracttypegrp: {
            nda: "NDA",
            advisoryorconsultancy: "Advisory or Consultancy",
            subcontratingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            otherservicesnoconstruction: "Other services (not build)", //TOADD
            otherservicesrelatedbuild: "Other services related to Build",
            otherservices: "Other Services",
            internalpurchases: "Internal Purchases",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdsprojectmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            design: "Design (only)",
            construction: "Build (only)",
            designandconstruction: "Design and Build",
            furnituresupply: "Furniture Supply",
            furniturelogisticsoperator: "Logistic Operator",
            extensionofworkservice: "Novation Variations or Extraworks ",
            discount: "Volume Discount Contracts (Rappel, prescription)",
            masterserviceagreement: "Master Service Agreement",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Installation of Materials (only) ",
            instalationandmaterials: "Instalação e Materiais",
            corporatepurchases: "Corporate Procurement (support)",
            certificateofmeetings: "Construction Meetings",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "Recibo IT",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        }
    },
    app: {
        lbl_title: "Segurança",
        lbl_text: "Ativando segurança, por favor aguarde ...",
        lbl_back_login: "Login do aplicativo...",
        lbl_load_roles: "Funções do usuário...",
        lbl_load_instance: "Carregando instância...",
        lbl_error_login: "Erro de login; se persistir, limpe o cache do navegador."
    },
    esign_hr: {
        title: "HR ESign Module",
        loading: "Loading...",
        form: {
            reqNumber: "Request Number",
            employee: {
                name: "Employee Name",
                email: "Employee Email"
            },
            society: "Society",
            contractType: "Contract Type",
            bDate: "Send now?",
            launchDate: "Contract Launch Date",
            bJLLsignee: "JLL signature required?",
            jllsigneeEmail1: "JLL Signatory (1)",
            jllsigneeEmail2: "JLL Signatory (2)",
            freeTextTitle: "Email body",
            freeText: "Free text to be included in the email requesting signatures",
            comments: "Comments",
            create: "New Request",
            edit: "Edit Request",
            review: "Review Request",
            dropdownoptions: {
                society: {
                    jll: "Jones Lang LaSalle España",
                    tetris: "Tétris Arquitectura",
                    ifm: "JLL Facility Services (IFM)"
                },
                contracttype: {
                    work: "Contrato de trabajo",
                    signature: "Firmas",
                    append: "Anexos",
                    other: "Otros"
                }
            }
        }
    }
};
